module.exports = __webpack_public_path__ + "img/22.d30d8702.png";